export class Privilege {

  public id: number;
  public name: string = '';

  public static createFromJson(json: any): Privilege {
    if(json == null){
      throw new Error('Privilege.createFromJson: json is null');
    }
    const instance = new Privilege();
    instance.id = json.id;
    instance.name = json.name;

    return instance;
  }

}
